import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordForm } from '../components/auth'
import { Container, Center } from '@mantine/core'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordComponent,
})

function ForgotPasswordComponent() {
  return (
    <Container size="sm" style={{ minHeight: '100vh' }}>
      <Center style={{ minHeight: '100vh' }}>
        <ForgotPasswordForm />
      </Center>
    </Container>
  );
}
